import React from "react";

import { useAppType, useGeneralContext, useLocation, useUserContext } from "utils";

import { Alert, Breadcrumbs, Flex } from "components";

import { ProfileMenu } from "pages/app/_app/components/profile-menu/ProfileMenu.tsx";

export const HeaderDesktop = () => {
  const { referralBanner, fullWidthPage, appNavSideCollapsed, navigationCrumbs } = useGeneralContext();
  const { largeDesktop } = useAppType();
  const { user } = useUserContext();
  const location = useLocation();

  const ReferralBanner = ({ text }: { text: string }) => (
    <Alert dataTestId="alert-banner" className="alert-banner" description={text} icon="" type="green" closable={true} onClick={() => {}} showArrow />
  );

  if (!user) {
    return <>{referralBanner && <ReferralBanner text={referralBanner.text} />}</>;
  }
  const isDigitalAgronomist = () => location?.pathname?.includes("/side-crop-recommender");

  return (
    <section
      className={`${isDigitalAgronomist() ? "digital-agronomist-container-width" : fullWidthPage ? "container-full-width" : "header-desktop nav-container"} ${
        appNavSideCollapsed || !largeDesktop ? "" : "menu-open"
      }`}
    >
      <Flex justify="center">
        <Flex className="header-desktop container" align="center" justify="space-between" gap={".5rem"}>
          {navigationCrumbs?.crumbs?.length ? (
            <Breadcrumbs
              className="breadcrumbs header"
              dataTestId="breadcrumbs"
              items={navigationCrumbs.crumbs}
              additionalData={navigationCrumbs.additionalData}
              size="m"
            />
          ) : (
            <></>
          )}
          <ProfileMenu />
        </Flex>
      </Flex>
    </section>
  );
};
